import { EuiBadge, EuiButtonIcon, EuiFilePicker, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiIcon, EuiListGroup, EuiListGroupItem, EuiPanel, EuiText } from '@elastic/eui';
import React, { useState, useEffect, useMemo, forwardRef, useImperativeHandle } from 'react';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { downloadFile } from '../../../../../shared/utils/download';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { toDecimalString } from '../../../../../shared/utils/numbers';
import { useLanguage } from '../../../../../shared/hooks/Language';

function omit(key, obj) {
  const { [key]: omitted, ...rest } = obj;
  return rest;
}


export const AdjuntosExpatriadosScreen=forwardRef((props, ref)=>{

    const {translate} = useLanguage();
    const api = new AdjuntosAdapter();
    const {disabled,multiple, idEmpleado, isEdit} = props;

    const [adjuntos, setAdjuntos] = useState({})
    const [filesToSave, setFilesToSave] = useState([]);
    const [originalFiles, setOriginalFiles] = useState([]);

    async function getAdjuntos(){
      const api = new AdjuntosAdapter();
      try {
        const result = await api.ListarAdjuntosExpatriado(idEmpleado);
        let adj = result.data;
        
        const file_list = adj.map((e,i) => { return {file:{name:e.nombre, type:e.tipo, size:e.longitud},idAdjunto:e.idAdjunto, key: i}}
        )
        setFilesToSave([...file_list]);
        //setOriginalFiles([...file_list]);
      }catch (error) {
            let exception = ServerErrorMessage(error);
            exception && alert("Error , " + exception.message);
          }
    }

  useEffect(()=>{
      if(!disabled){getAdjuntos()}
  },[disabled])

    useEffect(() => {
        if(adjuntos.length>0){
          const newFiles = [];
          let currentPos = Math.max(...filesToSave.map(f=> f.key))+1;
          Object.keys(omit('length',adjuntos)).forEach(item => {
            newFiles.push({file:adjuntos[item], idAdjunto:null, key: currentPos++});
          });

          setFilesToSave([...filesToSave, ...newFiles]);
        }
    }, [adjuntos]);

    
      useImperativeHandle(ref, () => ({
        onSaveAdjuntosExpatriado: () => {
          //const iguales = isEqual(filesToSave.map((f)=>f.file), originalFiles.map((f)=> f.file))
          //console.log('onSave adjuntos ', iguales, filesToSave)
        //  return !iguales ? filesToSave : undefined;
        return filesToSave;
        }
      }));


    const onDonwload = async(fileDownload)=>{
      const id = fileDownload.idAdjunto;
      const nombre = fileDownload.file.name;

      if(id===null){
        await downloadFile(fileDownload.file,nombre)
      }else{
        const fileDownload = await api.DescargarAdjuntoExpatriado(idEmpleado,id);
        if(fileDownload.data!==undefined){
          await downloadFile(fileDownload.data,nombre)
        }
      }
    }

    const onChange = (files) => {
    setAdjuntos(files);
    // (filePickerRef && filePickerRef.current) && filePickerRef.current.removeFiles()
    };

    const getSizeAdjuntos = useMemo(()=>{
        const tam = filesToSave.length>0 ? filesToSave.map((item, i) => (item.file.size)).reduce((total, size) =>{return total + size;}) : 0
        const kb = (tam / 1024)
        return kb>1000 ? `${toDecimalString((kb/1000))} MB` : `${toDecimalString(kb)} KB`
    },[filesToSave])

    const onRemove = (key) =>{
      const pos = filesToSave.findIndex((o) => o.key === key);
      let newData = [ ...filesToSave ];
      newData.splice(pos, 1);
      setFilesToSave([...newData])
    }

    const getSizeFile = (size)=>{
      const kb = (size / 1024)
      return kb>1000 ? `${toDecimalString((kb/1000))} MB` : `${toDecimalString(kb)} KB`
    }

  
    const renderOptions = () =>{
      return filesToSave.map((o)=>(
        <EuiFlexItem className='item-lista-adjunto-expatriados'>
          <EuiFlexGroup gutterSize='s' alignItems='center'>
          <EuiFlexItem grow={false}><EuiIcon type={"document"}/></EuiFlexItem>
          <EuiFlexItem className='text-file'><p title={`${o.file.name}`}>{`${o.file.name}`}</p></EuiFlexItem>
          <EuiFlexItem grow={false}><p>{`(${getSizeFile(o.file.size)})`}</p></EuiFlexItem>
          <EuiFlexItem grow={false}><EuiButtonIcon iconSize='s' iconType={"download"} title={translate('descargar')} onClick={()=>onDonwload(o)}/></EuiFlexItem>
          <EuiFlexItem grow={false}><EuiButtonIcon color='danger' iconSize='s' title={translate('eliminar-de-la-lista')} iconType={"crossInACircleFilled"} onClick={()=>onRemove(o.key)}/></EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      ))
    }

    const getList = () =>{
      return filesToSave.length>0 ? 
      <>
          <EuiFlexGroup direction='column' gutterSize='s' id='lista-adjuntos-expatriados'>
            {renderOptions()}
          </EuiFlexGroup>
      </>
      :
      <EuiFlexItem grow={false} key="danger">
        <EuiBadge color="danger">{translate('sin-datos')}</EuiBadge>
      </EuiFlexItem> 
  }

    return(
       <EuiPanel>
        <EuiFlexGroup direction='column'>
          <EuiFlexItem>
            <EuiFlexGroup gutterSize='xl'>
              <EuiFlexItem><h4>{translate('documentos-adjuntos')}</h4></EuiFlexItem>
              <EuiFlexItem style={{alignItems:'flex-end'}}><h4>{`${translate('tamaño')}: ${getSizeAdjuntos}`}</h4></EuiFlexItem>
              {/* <EuiFlexItem style={{alignItems:'flex-end'}}><h4>{isEdit ? `Ficheros Guardados` : `Tamaño: ${getSizeAdjuntos}`}</h4></EuiFlexItem> */}
            </EuiFlexGroup> 
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiFlexGroup>
              <EuiFlexItem id="adjuntos-expatriados-picker" style={{maxWidth:'320px', minWidth:'200px'}}>
                {/* <EuiFormRow label={`Documentos Adjuntos`}> */}
                  <EuiFilePicker
                      disabled={disabled}
                      multiple={multiple}
                      initialPromptText={translate('msg-seleccion-adjuntos')}
                      onChange={onChange}
                      {...props}
                  />
                {/* </EuiFormRow> */}
              </EuiFlexItem>
              <EuiFlexItem>
                {/* <EuiFormRow labelAppend={isEdit ? `Ficheros Guardados` : `Tamaño: ${getSizeAdjuntos}`}> */}
                  {!disabled?getList():null}
                {/* </EuiFormRow> */}
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
       </EuiPanel>
    )
})